import React, { useState } from "react";
import { motion } from "framer-motion";

export default function Denira() {
  const [activeTab, setActiveTab] = useState("thecontext");

  const theContentData = {
    title:
      "Desert regions are often defined by scarcity — limited infrastructure, reduced agricultural productivity, and restricted economic opportunities.",
    arrayData: [
      "Scarce and unreliable energy supply",
      "Semi-arid climate affecting traditional agriculture",
      "Underutilized land resources",
      "Communities with limited access to development opportunities",
    ],
  };

  const theOpportunityData = {
    title:
      "When viewed differently, the same conditions reveal powerful assets — abundant sun, available land, and strategic positioning for growth.",
    arrayData: [
      "High solar radiation for renewable energy generation",
      "Non-competitive land for sustainable cultivation",
      "Strategic logistics access for regional and export markets",
      "Strong foundation for integrated territorial development",
    ],
  };

  const theResponseData = {
    title:
      "We implement an integrated ecosystem that transforms natural conditions into sustainable economic drivers.",
    arrayData: [
      "Continuous renewable energy production",
      "Climate-resilient agricultural cultivation",
      "Biogas-based circular energy model",
      "Eco/agrotourism and value-added agricultural products",
    ],
  };

  const theCommitmentData = {
    title:
      "Our commitment goes beyond energy production — it is about long-term impact and shared prosperity.",
    arrayData: [
      "Creation of local jobs and skills development",
      "Carbon reduction and environmental regeneration",
      "Strengthening of local economies",
      "Sustainable development for future generations",
    ],
  };

  const CactusData = {
    title: "Cactus cultivation (2026)",
    arrayData: [
      "25,000 hectares",
      "350 hectares (initial phase)",
      "High efficiency in arid conditions",
    ],
  };

  const ecoagroData = {
    title: "Eco / agrotourism",
    arrayData: [
      "Immersive desert experiences",
      "Sustainable lodges",
      "Ecological trails covering 100 hectares",
    ],
  };

  const biogasUnitData = {
    title: "Biogas unit",
    arrayData: ["Capacity: 2.54 MW", "Continuous renewable energy generation"],
  };

  const pricklyPearData = {
    title: "Prickly pear production",
    arrayData: [
      "Dedicated area: 30 hectares",
      "Fresh fruit for premium markets",
      "High value-added processed products",
    ],
  };

  const supportServices = [
    {
      img: "/assets/img/CoiledTubing.svg",
      title: "Coiled tubing",
      description:
        "Continuous flexible tubing operations for well interventions.",
    },
    {
      img: "/assets/img/LightWellIntervention.svg",
      title: "Light well intervention",
      description: "Light interventions using advanced techniques.",
    },
    {
      img: "/assets/img/Slickline.svg",
      title: "Slickline",
      description: "Cable-based operations for diagnostics and repair.",
    },
    {
      img: "/assets/img/SolidsControl.svg",
      title: "Solids control",
      description: "Management and control of solids in drilling processes.",
    },
    {
      img: "/assets/img/QualifiedManpower.svg",
      title: "Qualified manpower",
      description: "Specialized technical teams for complex operations.",
    },
  ];

  const opportunityTabs = [
    {
      key: "thecontext",
      label: "The context",
      icon: "/assets/img/Thecontext.svg",
      iconActive: "/assets/img/ThecontextWhite.svg",
    },
    {
      key: "opportunity",
      label: "The opportunity",
      icon: "/assets/img/Theopportunity.svg",
      iconActive: "/assets/img/TheopportunityWhite.svg",
    },
    {
      key: "response",
      label: "Our response",
      icon: "/assets/img/Ourresponse.svg",
      iconActive: "/assets/img/OurresponseWhite.svg",
    },
    {
      key: "commitment",
      label: "The commitment",
      icon: "/assets/img/Thecommitment.svg",
      iconActive: "/assets/img/ThecommitmentWhite.svg",
    },
  ];

  return (
    <>
      <div className="container-fluid maxContainerSection commonPadding commonHeaderPadding">
        <div className="row">
          <div className="col-md-7">
            <div className="deniraLeftSection">
              <p className="m-0 f-s-20">
                What if we could transform the desert into clean energy?
              </p>
              <h1 className="m-0 f-s-60">QUIMENERGY</h1>
              <div className="deniraHrSection"></div>
              <p className="m-0 f-s-20">
                Technical excellence at the service of energy
              </p>
              <div className="promoterDenira">
                <p className="m-0 f-s-20">
                  Promoter of the DENIRA GREEN ENERGY project
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-5 deniraRightSection">
            <div className="heroDownArrow darianHeroIcon">
              <img src="/assets/img/deniraBusiness.png" alt="" />
            </div>

            <div>
              <p className="m-0 f-s-20">December {new Date().getFullYear()}</p>
              <div className="InstitutionalPresentation">
                <p className="m-0 innerInstitutionalPresentation">
                  Institutional presentation
                </p>
                <img
                  src="/assets/img/arrowLink.svg"
                  alt=""
                  className=" innerInsBtn"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="deniraBanner">
        <div className="deniraBannerColor"></div>
        <div className="container-fluid maxContainerSection deniraBannerImageSection">
          <div className="row">
            <div className="col-md-12">
              <img
                src="/assets/img/deniraBanner.png"
                alt=""
                className="deniraBannerImage img-fluid"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid maxContainerSection commonPadding">
        <div className="row">
          <div className="col-md-6">
            <motion.img
              src="/assets/img/deniraAbout.png"
              className="img-fluid"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            />
          </div>
          <div className="col-md-6 deniraAboutSection">
            <motion.h2
              className="mission-title m-0 f-s-48"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              We turn challenges into opportunities for Angola.
            </motion.h2>
            <motion.p
              className="mission-text m-0 f-s-20"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              QUIMENERGY is a 100% Angolan company operating in the oil sector
              with a transformative vision.
              <br />
              <br />
              We combine local technical expertise with international best
              practices to build a sustainable energy future.
              <br />
              <br />
              From traditional oil to clean energy, we are creating a legacy of
              innovation that strengthens communities and preserves the
              environment for future generations.
            </motion.p>
          </div>
        </div>
      </div>

      <div className="deniraSupportSection">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12 whowearehedaersection">
              <h2 className="m-0 f-s-48">Support to the oil & gas sector</h2>
              <p className="m-0 f-s-20">
                With the leading companies in the sector, ensuring excellence in
                specialized technical operations within the framework of Local
                Content.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 supportInnerCardSectionOuter">
              {supportServices.map((item, index) => (
                <div className="supportInnerCardSection" key={index}>
                  <img src={item.img} alt={item.title} />
                  <h6 className="m-0 f-s-24">{item.title}</h6>
                  <p className="m-0 f-s-20">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid maxContainerSection commonPadding">
        <div className="row">
          <div className="col-md-12 whowearehedaersection deniraHeaderSection">
            <h2 className="m-0 f-s-48">From scarcity to opportunity</h2>
            <p className="m-0 f-s-20">
              Seeing the desert as potential unlocks new paths for clean energy,
              resilient agriculture, and sustainable growth. What was once a
              limitation becomes a foundation for innovation and long-term
              development.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 OpportunityTabsCol">
            <div className="OpportunityTabsOuter">
              {opportunityTabs.map((tab) => (
                <div
                  key={tab.key}
                  className={`OpportunityTabs ${
                    activeTab === tab.key ? "OpportunityTabsActive" : ""
                  }`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  <img
                    src={activeTab === tab.key ? tab.iconActive : tab.icon}
                    alt={tab.label}
                  />
                  <p className="m-0 f-s-20">{tab.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {activeTab === "thecontext" && (
          <div className="row opportunityContentSec">
            <div className="col-md-6">
              <motion.h6
                className="mission-title m-0 f-s-24"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {theContentData.title}
              </motion.h6>

              <div className="pointsopportunity">
                {theContentData?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                    className="energysectionpoints f-s-20"
                  >
                    <img src="/assets/img/greenTick.svg" alt="" /> {item}
                  </motion.div>
                ))}
              </div>
            </div>
            <div className="col-md-6 opportunityImage">
              <motion.img
                src="/assets/img/Thecontext.png"
                className="img-fluid"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              />
            </div>
          </div>
        )}

        {activeTab === "opportunity" && (
          <div className="row opportunityContentSec">
            <div className="col-md-6">
              <motion.h6
                className="mission-title m-0 f-s-24"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {theOpportunityData.title}
              </motion.h6>

              <div className="pointsopportunity">
                {theOpportunityData?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                    className="energysectionpoints f-s-20"
                  >
                    <img src="/assets/img/greenTick.svg" alt="" /> {item}
                  </motion.div>
                ))}
              </div>
            </div>
            <div className="col-md-6 opportunityImage">
              <motion.img
                src="/assets/img/opportunity.png"
                className="img-fluid"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              />
            </div>
          </div>
        )}

        {activeTab === "response" && (
          <div className="row opportunityContentSec">
            <div className="col-md-6">
              <motion.h6
                className="mission-title m-0 f-s-24"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {theResponseData.title}
              </motion.h6>

              <div className="pointsopportunity">
                {theResponseData?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                    className="energysectionpoints f-s-20"
                  >
                    <img src="/assets/img/greenTick.svg" alt="" /> {item}
                  </motion.div>
                ))}
              </div>
            </div>
            <div className="col-md-6 opportunityImage">
              <motion.img
                src="/assets/img/response.png"
                className="img-fluid"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              />
            </div>
          </div>
        )}

        {activeTab === "commitment" && (
          <div className="row opportunityContentSec">
            <div className="col-md-6">
              <motion.h6
                className="mission-title m-0 f-s-24"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {theCommitmentData.title}
              </motion.h6>

              <div className="pointsopportunity">
                {theCommitmentData?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                    className="energysectionpoints f-s-20"
                  >
                    <img src="/assets/img/greenTick.svg" alt="" /> {item}
                  </motion.div>
                ))}
              </div>
            </div>
            <div className="col-md-6 opportunityImage">
              <motion.img
                src="/assets/img/commitment.png"
                className="img-fluid"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              />
            </div>
          </div>
        )}
      </div>

      <div className="UnlockingNamibeBg">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12 whowearehedaersection deniraHeaderSection">
              <h2 className="m-0 f-s-48">Unlocking namibe's potential</h2>
              <p className="m-0 f-s-20">
                Namibe's natural conditions, strategic location, and available
                land create a unique opportunity to turn environmental
                challenges into sustainable energy, resilient agriculture, and
                long-term economic growth.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 UnlockingNamibeImages">
              <motion.img
                src="/assets/img/unlockingnamibe1.png"
                className="img-fluid"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              />

              <motion.img
                src="/assets/img/unlockingnamibe2.png"
                className="img-fluid unlockingnamibe2"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              />

              <motion.img
                src="/assets/img/unlockingnamibe3.png"
                className="img-fluid unlockingnamibe3"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              />
            </div>
            <div className="col-md-6 potentialSectinoCol">
              <div className="potentialSectinoRight">
                <img src="/assets/img/Uniquenatural.svg" alt="" />
                <div>
                  <h6 className="m-0 f-s-20">Unique natural conditions</h6>
                  <p className="m-0 f-s-16">
                    High solar radiation + low rainfall = an ideal environment
                    for cactus cultivation and clean energy production.
                  </p>
                </div>
              </div>

              <div className="potentialSectinoRight">
                <img src="/assets/img/Strategicland.svg" alt="" />
                <div>
                  <h6 className="m-0 f-s-20">Strategic land</h6>
                  <p className="m-0 f-s-16">
                    Low-cost sandy soils without competing with traditional food
                    crops.
                  </p>
                </div>
              </div>

              <div className="potentialSectinoRight">
                <img src="/assets/img/Logisticsadvantages.svg" alt="" />
                <div>
                  <h6 className="m-0 f-s-20">Logistics advantages</h6>
                  <p className="m-0 f-s-16">
                    Direct access to the Lobito Corridor and the Port of
                    Moçâmedes for exports.
                  </p>
                </div>
              </div>

              <div className="potentialSectinoRight">
                <img src="/assets/img/Transforminglimitations.svg" alt="" />
                <div>
                  <h6 className="m-0 f-s-20">Transforming limitations</h6>
                  <p className="m-0 f-s-16">
                    Namibe makes it possible to turn challenges into economic,
                    social, and environmental opportunities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid maxContainerSection commonPadding">
        <div className="row">
          <div className="col-md-12 whowearehedaersection deniraHeaderSection">
            <h2 className="m-0 f-s-48">
              Building an ecosystem that transforms lives
            </h2>
            <p className="m-0 f-s-20">
              By integrating clean energy, premium agricultural production,
              sustainable tourism, and social impact, we create a circular model
              that turns natural resources into long-term economic and community
              value.
            </p>
          </div>
        </div>

        <div className="row ecoSystemContentSec">
          <div className="col-md-6">
            <div className="PeopleSafetyMain paddingbottom10">
              <div className="PeopleSafetyOuter ecosystemSafetyOuter">
                <img src="/assets/img/SustainableBiogas.svg" alt="" />
                <h6 className="m-0 f-s-20">Sustainable biogas</h6>
                <p className="m-0 f-s-16">
                  Clean and continuous energy generated from cacti, transforming
                  the desert into a source of life.
                </p>
              </div>

              <div className="PeopleSafetyOuter ecosystemSafetyOuter ecosystemactive">
                <img src="/assets/img/PremiumProducts.svg" alt="" />
                <h6 className="m-0 f-s-20">Premium products</h6>
                <p className="m-0 f-s-16">
                  High-value products for national and international markets.
                </p>
              </div>
            </div>

            <div className="PeopleSafetyMain">
              <div className="PeopleSafetyOuter ecosystemSafetyOuter ecosystemactive">
                <img src="/assets/img/EcoAgrotourism.svg" alt="" />
                <h6 className="m-0 f-s-20">Eco & agrotourism</h6>
                <p className="m-0 f-s-16">
                  Experiences that highlight local biodiversity and the cultural
                  richness of the territory.
                </p>
              </div>
              <div className="PeopleSafetyOuter ecosystemSafetyOuter">
                <img src="/assets/img/SocialImpact.svg" alt="" />
                <h6 className="m-0 f-s-20">Social impact</h6>
                <p className="m-0 f-s-16">
                  Job creation, skills development, and the empowerment of local
                  knowledge.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 ecosystemRight">
            <motion.img
              src="/assets/img/ecosystem.png"
              className="img-fluid"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            />
          </div>
        </div>
      </div>

      <div className="cactusSectionOuter">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12 whowearehedaersection deniraHeaderSection">
              <h2 className="m-0 f-s-48">From cactus to continuous power</h2>
              <p className="m-0 f-s-20">
                By combining resilient cactus cultivation with advanced biogas
                technology, we convert natural biomass into clean, reliable
                energy—delivering sustainable <span>power 24/7</span> while
                supporting agriculture, industry, and local communities.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="cactusCardLeftSection">
                <div className="cactusCardSection">
                  <div className="CactuscultivationImg">
                    <img
                      src="/assets/img/Cactuscultivation.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <div className="CactuscultivationContent">
                    <motion.h3
                      className="mission-title m-0 f-s-48"
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6 }}
                      viewport={{ once: true }}
                    >
                      {CactusData.title}
                    </motion.h3>
                    {CactusData?.arrayData?.map((item, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                        viewport={{ once: true }}
                      >
                        <div className="energysectionpoints f-s-18">
                          <img src="/assets/img/greenTick.svg" alt="" /> {item}
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>

                <div className="cactusCardSection">
                  <div className="CactuscultivationImg">
                    <img
                      src="/assets/img/EcoAgrotourism.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <div className="CactuscultivationContent">
                    <motion.h3
                      className="mission-title m-0 f-s-48"
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6 }}
                      viewport={{ once: true }}
                    >
                      {ecoagroData.title}
                    </motion.h3>
                    {ecoagroData?.arrayData?.map((item, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                        viewport={{ once: true }}
                      >
                        <div className="energysectionpoints f-s-18">
                          <img src="/assets/img/greenTick.svg" alt="" /> {item}
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="cactusCardRightSection">
                <div className="cactusCardSection">
                  <div className="CactuscultivationImg">
                    <img
                      src="/assets/img/Biogasunit.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <div className="CactuscultivationContent">
                    <motion.h3
                      className="mission-title m-0 f-s-48"
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6 }}
                      viewport={{ once: true }}
                    >
                      {biogasUnitData.title}
                    </motion.h3>
                    {biogasUnitData?.arrayData?.map((item, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                        viewport={{ once: true }}
                      >
                        <div className="energysectionpoints f-s-18">
                          <img src="/assets/img/greenTick.svg" alt="" /> {item}
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>

                <div className="cactusCardSection">
                  <div className="CactuscultivationImg">
                    <img
                      src="/assets/img/PricklyPear.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>

                  <div className="CactuscultivationContent">
                    <motion.h3
                      className="mission-title m-0 f-s-48"
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6 }}
                      viewport={{ once: true }}
                    >
                      {pricklyPearData.title}
                    </motion.h3>
                    {pricklyPearData?.arrayData?.map((item, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                        viewport={{ once: true }}
                      >
                        <div className="energysectionpoints f-s-18">
                          <img src="/assets/img/greenTick.svg" alt="" /> {item}
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid maxContainerSection commonPadding">
        <div className="row">
          <div className="col-md-12 whowearehedaersection deniraHeaderSection">
            <h2 className="m-0 f-s-48">Scaling for Impact</h2>
            <p className="m-0 f-s-20">
              A phased expansion plan that grows from
              <span>400 to 5,000 hectares,</span>
              increasing capacity, production, and long-term sustainable value
              at every stage.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="hectaresSectionMainHr"></div>
            <div className="hectaresSectionOuter">
              <div className="hectaresSection">
                <div className="hectarDot"></div>
                <h6 className="m-0 f-s-20">2026</h6>
                <p className="m-0 f-s-20">400 ha</p>
              </div>

              <div className="hectaresSection">
                <div className="hectarDot"></div>
                <h6 className="m-0 f-s-20">2027</h6>
                <p className="m-0 f-s-20">1000 ha</p>
              </div>

              <div className="hectaresSection">
                <div className="hectarDot"></div>
                <h6 className="m-0 f-s-20">2029</h6>
                <p className="m-0 f-s-20">4000 ha</p>
              </div>

              <div className="hectaresSection">
                <div className="hectarDot"></div>
                <h6 className="m-0 f-s-20">2031</h6>
                <p className="m-0 f-s-20">5000 ha</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row hectaresPriceCardRow">
          <div className="col-md-4">
            <div className="hectaresPriceCard">
              <div className="PilotIconSec f-s-24">Pilot</div>
              <div className="hectaresPriceCardHeader">
                <div>
                  <h3 className="m-0 f-s-32">Start</h3>
                  <p className="m-0 f-s-20">2026-2027</p>
                </div>
                <h1 className="">1</h1>
              </div>

              <div>
                <h3 className=" m-0 f-s-36 hectaresPrice">
                  400 <img src="/assets/img/arrowRightgreen.svg" alt=" " />
                  1.000 ha
                </h3>
                <div className="energysectionpoints f-s-16">
                  <img src="/assets/img/greenTick.svg" alt="" />
                  Pilot with 400 hectares
                </div>

                <div className="energysectionpoints f-s-16">
                  <img src="/assets/img/greenTick.svg" alt="" />
                  Second biogas unit integrated in 2027
                </div>

                <div className="energysectionpoints f-s-16">
                  <img src="/assets/img/greenTick.svg" alt="" />
                  Start of commercial biogas production
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="hectaresPriceCard">
              <div className="hectaresPriceCardHeader">
                <div>
                  <h3 className="m-0 f-s-32">Expansion</h3>
                  <p className="m-0 f-s-20">2028-2029</p>
                </div>
                <h1 className="">2</h1>
              </div>

              <div>
                <h3 className=" m-0 f-s-36 hectaresPrice">4.000 ha</h3>
                <div className="energysectionpoints f-s-16">
                  <img src="/assets/img/greenTick.svg" alt="" />
                  Increase in commercial biogas production
                </div>

                <div className="energysectionpoints f-s-16">
                  <img src="/assets/img/greenTick.svg" alt="" />
                  Expansion of prickly pear production
                </div>

                <div className="energysectionpoints f-s-16">
                  <img src="/assets/img/greenTick.svg" alt="" />
                  Launch of the ecotourism component
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="hectaresPriceCard ConsolidationCard">
              <div className="hectaresPriceCardHeader">
                <div>
                  <h3 className="m-0 f-s-32">Consolidation</h3>
                  <p className="m-0 f-s-20">2030-2031</p>
                </div>
                <h1 className="">3</h1>
              </div>

              <div>
                <h3 className=" m-0 f-s-36 hectaresPrice">5.000 ha</h3>
                <div className="energysectionpoints f-s-16">
                  <img src="/assets/img/greenTick.svg" alt="" />
                  Full operation of the three strategic pillars
                </div>

                <div className="energysectionpoints f-s-16">
                  <img src="/assets/img/greenTick.svg" alt="" />
                  +220,000 annual carbon credits
                </div>

                <div className="energysectionpoints f-s-16">
                  <img src="/assets/img/greenTick.svg" alt="" />
                  Full ROI within 2–3 years after operation
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h3 className="m-0 projectInvestment f-s-32">
              Total project investment: €220 million
            </h3>
          </div>
        </div>
      </div>

      <div className="deniraSupportSection energydesert">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-6 energyDesertSec">
              <h2 className="f-s-48 m-0">
                More than energy.
                <br /> A future built in the desert.
              </h2>
              <p className="m-0 f-s-20">
                We transform limitations into sustainable opportunities. DENIRA
                GREEN ENERGY represents a new way of thinking about integrated
                territorial development for Angola.
              </p>
              <div className="TransformationBtn f-s-20">
                Be part of this transformation
              </div>
              <p className="m-0 f-s-20">QUIMENERGY — DENIRA GREEN ENERGY</p>
            </div>
            <div className="col-md-6">
              <div className="energyDesertCard">
                <div>
                  <img src="/assets/img/thunder.svg" alt="" />
                </div>
                <div className="energyDesertCardDetails">
                  <h6 className="m-0 f-s-28">Energy diversification</h6>
                  <p className="m-0 f-s-18">
                    135 million m³ of biogas annually, 58 MW of continuous
                    power, and integration into the national energy grid.
                  </p>
                </div>
              </div>

              <div className="energyDesertCard">
                <div>
                  <img src="/assets/img/multiuser.svg" alt="" />
                </div>
                <div className="energyDesertCardDetails">
                  <h6 className="m-0 f-s-28">Territorial development</h6>
                  <p className="m-0 f-s-18">
                    +300 direct jobs, population retention, and strengthening of
                    the local economy in Namibe.
                  </p>
                </div>
              </div>

              <div className="energyDesertCard">
                <div>
                  <img src="/assets/img/earth.svg" alt="" />
                </div>
                <div className="energyDesertCardDetails">
                  <h6 className="m-0 f-s-28">Environmental sustainability</h6>
                  <p className="m-0 f-s-18">
                    +220,000 annual carbon credits, transforming the desert into
                    a sustainable economic asset.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
